import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/site/Logo";

export const LegalLayout = ({ title, children }) => (
  <div className="min-h-screen bg-sand">
    <header className="bg-white border-b border-border">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
        <Link to="/" aria-label="Zur Startseite"><Logo /></Link>
        <Link to="/" className="inline-flex items-center gap-2 text-sm font-medium text-forest hover:text-forest-dark transition-colors">
          <ArrowLeft className="w-4 h-4" /> Zur Startseite
        </Link>
      </div>
    </header>
    <main className="max-w-3xl mx-auto px-4 sm:px-6 py-14">
      <h1 className="font-heading font-extrabold tracking-tight text-3xl sm:text-4xl text-charcoal mb-8">{title}</h1>
      <div className="prose-legal space-y-6 text-charcoal-muted leading-relaxed [&_h2]:font-heading [&_h2]:font-bold [&_h2]:text-charcoal [&_h2]:text-xl [&_h2]:mt-8 [&_h2]:mb-2 [&_p]:text-base">
        {children}
      </div>
    </main>
  </div>
);
